/**
 * This component will work for sorting the filter
 *
 * @module views/components/FilterSortAction
 * @memberof -Common
 */
import './FilterSortAction.scss';

import React, { useCallback } from 'react';

import PropTypes from 'prop-types';

import RadioButton from '@ulta/core/components/RadioButton/RadioButton';
import Text from '@ulta/core/components/Text/Text';

import { FILTER_EVENT } from '@ulta/utils/constants/filters';

import * as utils from './FilterSortAction';

/**
 * Represents a FilterSortAction component
 *
 * @method
 * @param {FilterResultsActionProps} props - React properties passed from composition
 * @returns FilterSortAction
 */
export const FilterSortAction = function( props ){
  const {
    action,
    selected,
    applySortUrl,
    setFilterRequest,
    id
  } = props;

  if( !action ){
    return null;
  }

  const onSortFilterClick = useCallback(
    utils.composeOnSortFilterClick( { action, applySortUrl, id }, { setFilterRequest } ),
    [action, applySortUrl, id]
  );

  return (
    <li className='FilterSortAction'>
      <RadioButton
        name='FilterSortAction'
        isChecked={ !!selected }
        id={ action?.label }
        value={ action?.label }
        onChange={ onSortFilterClick }
        action={ action }
      >
        <Text htmlTag='span'> { action?.label }</Text>
      </RadioButton>
    </li>
  );
};

/**
  * @method composeOnSortFilterClick
  * @summary Filter list item click handler
  * @param {object} methods - passing setFilterRequest functions
  * @param {object} data - passing action, applySortUrl, id
  * @returns {function} filter callback
  */
export const composeOnSortFilterClick = ( data, methods ) => () => {
  const { setFilterRequest } = methods || {};
  const { action, applySortUrl, id } = data || {};

  if( !setFilterRequest || !action || !applySortUrl || !id ){
    return;
  }

  setFilterRequest( {
    id,
    action,
    clientUrl: applySortUrl,
    event: FILTER_EVENT.SORT
  } );
};

/**
 * Property type definitions
 * @typedef FilterSortActionProps
 * @type {object}
 * @property { object.<{label: string, url: string, graphql: string }> } action - Provides the label, url & graphql query
 * @property { boolean } selected - if the option is selected or not
 * @property { string } applySortUrl - url to apply sort
 * @property { function } setFilterRequest - sends request to DXL
 * @property { string } id - id of the object
 */
export const propTypes =  {
  action: PropTypes.shape( {
    label: PropTypes.string,
    url: PropTypes.string,
    graphql: PropTypes.string
  } ),
  selected: PropTypes.bool,
  applySortUrl: PropTypes.string,
  setFilterRequest: PropTypes.func,
  id: PropTypes.string
};

FilterSortAction.propTypes = propTypes;
export default FilterSortAction;
